import { render, staticRenderFns } from "./SpecialPlus.vue?vue&type=template&id=b486e528&scoped=true"
import script from "./SpecialPlus.vue?vue&type=script&lang=js"
export * from "./SpecialPlus.vue?vue&type=script&lang=js"
import style0 from "./SpecialPlus.vue?vue&type=style&index=0&id=b486e528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b486e528",
  null
  
)

export default component.exports